// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"GS_Section1_contentSection__FR-JM","customContainer":"GS_Section1_customContainer__3a4G9"};